import { DataTable } from '@/components/ui/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { ApplicationsBreadcrumb } from '../ApplicationsBreadcrumbs'
import { useCurrentApplication } from '../useCurrentApplication'
import { appTeamsTableColumnsV2 } from './AppsTeamsTable/appTeamsTableColumnsV2'
import { ApplicationTeamForm } from '../Forms/ApplicationTeamForm'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Suspense } from 'react'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'

export const AppTeamsPage = () => {
  return (
    <>
      <ApplicationsBreadcrumb title="Teams" />
      <QueryErrorBoundary errorMessage="Failed to fetch teams">
        <Suspense fallback={<DataTableLoading />}>
          <AppTeamsPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function AppTeamsPanelContent() {
  const { applicationId } = useCurrentApplication()
  const { getApplicationsApiGetApplicationTeamsForUserOrganization } = useRestClient()

  const { data: applicationTeams } = getApplicationsApiGetApplicationTeamsForUserOrganization.useSuspenseQuery({
    path: { appId: applicationId },
  })

  return (
    <TablePageContainer>
      <DataTable
        columns={appTeamsTableColumnsV2}
        data={applicationTeams}
        action={
          <ApplicationTeamForm
            sheetTitle="Add a team"
            sheetTrigger={
              <Button size="sm" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add team
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
